import { uniqBy, flatMap } from 'lodash';

export const convertToNull = (obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    acc[key] = null;
    return acc;
  }, {});
};

export const getDefaultValueForFilters = (filterOptions) => {
  return filterOptions.reduce((acc, option) => {
    acc[option.filter] = '';
    return acc;
  }, {});
};

// Function to include all data in the data object
export const includeCombinedData = (data, type) => {  
  // Get the key field based on the grid type (customer or bill)
  const keyField = type === 'customer' ? ['customerCode', 'terminal'] : ['proId'];
 // Flatten the data and remove duplicates based on the key field
  const allData = uniqBy(flatMap(data), (item) => {
    // Create a composite key from multiple fields
    return keyField.map(field => item[field]).join('|');
  });
  
  return {
    ...data,
    all: allData
  };
};

